/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import NotFound from '../components/NotFound';
import Error from '../components/Error';
import { MessageWrapper } from '../components/App/Common/MessageWrapper';
import { getUrlParamValue } from '../util/urlTools';

const PrivateRoute = (props) => {
  const { WITH_LOGIN, WITH_ARAGON_LOGIN, AUTH_TOKEN_FROM_URL_PARAM, AUTH_TOKEN_FROM_URL_PARAM_NAME, showComponent, isLoggedIn, isLoggingIn, message } = props;
  const isShown = showComponent === undefined ? true : showComponent;
  const open = !!message;
  const myProps = { ...props, component: isShown && !open ? props.component : NotFound };
  const errorMsg = <Error message="Error de acceso" />;
  

  if (WITH_ARAGON_LOGIN && !isLoggedIn) {
    if (isLoggingIn) {
      return <MessageWrapper>Verificando acceso...</MessageWrapper>;
    }
    return errorMsg;
  }

  if (WITH_LOGIN && AUTH_TOKEN_FROM_URL_PARAM) {
    if (typeof getUrlParamValue(AUTH_TOKEN_FROM_URL_PARAM_NAME) === 'string' ) {
      return <Route {...myProps} />;
    }
  } 

  if (!WITH_ARAGON_LOGIN && WITH_LOGIN && !isLoggedIn) {
    const url = new URL(window.location.href);
    window.route = url.pathname;
    return <Redirect to="/" />;
  }

  return <Route {...myProps} />;
};

export { PrivateRoute };
